import { GQLIdEncoder } from '../../../../../../common/utils/GQLIdEncoder';
import { Key } from '../../models/valueObjects/Key';

export class KeyMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Key {
    return new Key(this.gqlIdEncoder.decode(data.id), data.shortDescription);
  }
}
